import { html } from 'lit';
import { until } from 'lit/directives/until.js';
import { culture } from '../intl';

const API_URL_BASE = '/api/translations';

class Resource {
	constructor(key) {
		this.key = key;
		this.labels = null;
		this.labelsPromise = null;
	}

	async loadLabels() {
		if (this.labels) return this.labels;

		if (!this.labelsPromise) {
			this.labelsPromise = fetch(`${API_URL_BASE}/${this.key}/${culture}`)
				.then((response) => {
					if (!response.ok) throw new Error(`Failed to load ${this.key} labels`);
					return response.json();
				})
				.then((data) => {
					this.labels = data;
					this.labelsPromise = null;
					return data;
				})
				.catch((err) => {
					this.labelsPromise = null;
					throw err;
				});
		}

		return this.labelsPromise;
	}

	async getLabel(key) {
		const labels = await this.loadLabels();

		return labels?.[key];
	}
}

const resources = new Map();

const getTranslation = async (resourceName, labelKey, fallback) => {
	if (!resources.has(resourceName)) {
		resources.set(resourceName, new Resource(resourceName));
	}

	const resourceInstance = resources.get(resourceName);

	try {
		const label = await resourceInstance.getLabel(labelKey);

		if (label) {
			return label;
		}

		console.warn(`label ${labelKey} not found`);
		return fallback;
	} catch {
		console.warn(`There was an error fetching resource ${resourceName}`);

		return fallback;
	}
};

const translate = (resource, label, fallback) => until(getTranslation(resource, label, fallback), html`${fallback}`);

export default translate;
export { getTranslation };
